import { t } from "i18next";
import React, { useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import InstanceIndex from "../../../components/UI/AddingData/InstanceIndex";
import TextInput from "../../../components/UI/AddingData/TextInput";
import {
  shortIdGenerator,
} from "../../../customFunction/IDGenerator";
import ReactToPrint from "react-to-print";
import QRCode from "react-qr-code";
import { View, Image } from "react-native";
import { showInIQD } from "../../../customFunction/Numeral/CurrencyFormat";
import useQuery from "../../../customFunction/useQuery";
import useSWR from "swr";
import { fetcher, Loading } from "../../UI/CentersViewData";
import axios from "axios";
import CommonInputsContainer from "../../../components/UI/TableView/CommonInputsContainer";
import { IoPrintOutline } from "react-icons/io5";

function CaffeteriaGuestUserCollectionDetails() {
  const id = useParams().id;

  const isNew = useQuery().get("isNew");
  const { data, isLoading, error } = useSWR(
    "/cafeteria-guest-users/" + id + "?isNew=" + isNew,
    fetcher
  );
  const [currentData, setCurrentData] = useState({
    value: "",
    price: "",
    collectionId: shortIdGenerator(),
  });
  const history = useHistory();

  useEffect(() => {
    setup();
  }, [data]);

  const setup = () => {
    if (data && data[0]) {
      setCurrentData(data[0]);
    }
  };

  const onChangeValue = (type, value) => {
    let obj = currentData;

    if (type === 0) {
      obj.value = Number(value);
    }
    if (type === 1) {
      obj.price = Number(value);
    }
    if (type === 2) {
      obj.color = value;
    }

    setCurrentData({ ...obj });
  };

  const onSubmit = async () => {
    if (!isNew) {
      return
    }
    try {
      if (!currentData.value || !currentData.price) {
        alert('Please fill all the fields')
        return
      }
      await axios.post("/cafeteria-guest-users", currentData);
      history.goBack();
    } catch (e) {
      console.log(e);
      alert(e);
    }
  };

  const componentRef = useRef();

  if (isLoading) return <Loading />

  return (
    <div className="flex flex-col items-center flex-1 w-full ">

      <div className="flex flex-1 w-full">
        <CommonInputsContainer printIcon={currentData.ids ? <ReactToPrint trigger={() => <IoPrintOutline size={32} color='green' className="cursor-pointer" />} content={() => componentRef.current} /> : null} onSave={currentData.ids?null:onSubmit} title={t('cafeteria')} >
          <InstanceIndex label={t("id")} value={`#${currentData && (currentData._id || currentData.collectionId) ? currentData._id || currentData.collectionId : ''}`} />
          <TextInput
            label={t("numberOfGuestUsers")}
            placeHolder={t("numberOfGuestUsers")}
            value={currentData.value || currentData?.ids?.length}
            onChangeValue={onChangeValue}
            type={0}
          />
          <TextInput
            label={`${t("iqd")}`}
            placeHolder={t("realPrice")}
            value={currentData?.price}
            onChangeValue={onChangeValue}
            type={1}
          />
          {currentData.ids && <TextInput
            label={`${t("color")}`}
            placeHolder={t("color")}
            value={currentData.color}
            onChangeValue={onChangeValue}
            type={2}
          />}
        </CommonInputsContainer>
      </div >
      <div style={{ display: "none" }}>
        <ComponentToPrint
          currentData={currentData}
          ref={componentRef}
        />
      </div>

    </div>
  );
}

export const ComponentToPrint = React.forwardRef((props, ref) => {
  const { currentData } = props;
  // console.log(currentData)
  return (
    <View
      ref={ref}
      style={{
        flex: "display",
        width: "100%",
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap",
        paddingHorizontal: 7,
        backgroundColor: currentData?.color || "#012623",
      }}
    >
      {currentData.ids &&
        currentData.ids.map((dt, i) => {
          if (!dt) return <View></View>;

          return (
            <View
              key={i}
              style={{
                height: 154.5,
                width: 240,
                margin: 3,
                alignItems: "center",
                justifyContent: "space-between",
                flexDirection: "row",
                paddingHorizontal: 10,
              }}
            >
              <View style={{ width: "50%" }}>
                <QRCode
                  value={dt + ""}
                  level="M"
                  key={i}
                  size={100}
                  title={i}
                  bgColor={currentData?.color || "#012623"}
                  fgColor="#fff"
                />
              </View>
              <View
                style={{
                  height: 100,
                  width: "50%",
                  alignItems: "flex-start",
                  justifyContent: "space-evenly",
                }}
              >
                <p style={{
                    fontSize: 23,
                    color: "#fff",
                    fontWeight: "700",
                    // marginTop: -14,
                  }} >
                  H&H Gym
                </p>

                <p
                  style={{
                    fontSize: 23,
                    color: "#fff",
                    fontWeight: "700",
                    marginTop: -6,
                  }}
                >
                  {showInIQD(currentData?.price, "IQD", "IQD")}
                </p>
                <p
                  style={{
                    fontSize: 6,
                    fontFamily: "Montserrat",
                    color: "#fff",
                  }}
                >
                  This gift card is used for purchases in the cafeteria of H&H Gym. H&H Gym is not responsible for loss or
                  tearing after purchase
                </p>
                <p style={{
                  fontSize: 6,
                }} className="text-white/60" >{i + 1}</p>
              </View>
            </View>
          );
        })}
    </View>
  );
});


export default CaffeteriaGuestUserCollectionDetails;
